export default "<button class=\"button-primary button-primary--{{size}}\" [disabled]=\"disabled\">\n  <ion-label>{{Text}}</ion-label>\n</button>\n\n";